import { Badge, Button, Col, DatePicker, Dropdown, Row, Select } from "antd";
import { Field, Form, Formik } from "formik";
import React, { FC, useEffect, useState } from "react";
import "./instituteFilter.scss";
import FilterIcon from "../../../assets/icons/filter-icon-filled.svg";
import CalendarIcon from "../../../assets/icons/calendar-primary.svg";
import { DashboardFilterModel, StudentActivitiesFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";
import moment from "moment";

import AuthContainer from "../../../store/container/AuthContainer";

const { RangePicker } = DatePicker;
interface DashboardFilterProps {
  applyHandler: (values: DashboardFilterModel) => void;
  clearHandler: () => void;
}

const InstituteFilter: FC<DashboardFilterProps> = (props) => {
  const {
    applyHandler,
    clearHandler,
  } = props;

  const [initialValues, setInitialValues] = useState<DashboardFilterModel>({});
  const [defaultValues, setDefaultValues] = useState<DashboardFilterModel>({});
  const [open, setOpen] = useState<boolean>(false);

  const fetchCount = () => {
    let count = 0;
    if (initialValues?.startingDate) count += 1;
    if (initialValues?.endingDate) count += 1;
    return count;
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {}}
      enableReinitialize
    >
      {({ values, setFieldValue, resetForm }) => (
        <Form
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <Dropdown
            overlayClassName="dashboard-filter__overlay"
            className="dashboard-filter"
            trigger={["click"]}
            onOpenChange={(open: boolean) => setOpen(open)}
            open={open}
            overlay={
              <div className="dashboard-filter-form__wrapper">
                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <label>Date Range</label>
                  <Field
                    name="date"
                    as={RangePicker}
                    value={[
                      values?.startingDate
                        ? moment(values?.startingDate, "YYYY-MM-DD")
                        : undefined,
                      values?.endingDate
                        ? moment(values?.endingDate, "YYYY-MM-DD")
                        : undefined,
                    ]}
                    onChange={(dates) => {
                      if (dates?.length) {
                        setFieldValue(
                          "startingDate",
                          moment(dates?.[0])?.format("YYYY-MM-DD")
                        );
                        setFieldValue(
                          "endingDate",
                          moment(dates?.[1])?.format("YYYY-MM-DD")
                        );
                      } else {
                        setFieldValue("startingDate", 0);
                        setFieldValue("endingDate", 0);
                      }
                    }}
                    suffixIcon={
                      <img className="calendar__icon" src={CalendarIcon} />
                    }
                  />
                </div>
                <div
                  className="dashboard-filter-form__field"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                ></div>

                <Row gutter={12} className="dashboard-filter__controllers">
                  <Col span={12}>
                    <Button
                      type="default"
                      onClick={() => {
                        resetForm({});
                        setInitialValues(defaultValues);
                        applyHandler(defaultValues);
                        clearHandler();
                      }}
                    >
                      Clear Filters
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      type="primary"
                      onClick={() => {
                        resetForm({ values });
                        setInitialValues(values);
                        applyHandler(values);
                        setOpen(false);
                      }}
                    >
                      Apply Filters
                    </Button>
                  </Col>
                </Row>
              </div>
            }
          >
            <Badge count={fetchCount()}>
              <div className="filter__icon">
                <img src={FilterIcon} />
              </div>
            </Badge>
          </Dropdown>
        </Form>
      )}
    </Formik>
  );
};

export default AuthContainer(InstituteFilter);
